import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ClampLines from 'react-clamp-lines';
import truncate from 'lodash/truncate';
import {
	Message, MessageWrapper, TextBoxWrapper, Triangle, User,
} from './components';
import {
	animateFullScreen,
	animateToBackground,
	animateToGrid,
	bindRotateAnimation,
	bindUserRotateAnimation,
	prepareAnimations,
	toggleAnimations,
} from '../animatedVisualizations/animations';

import options from '../animatedVisualizations/options';
import * as actions from '../../../../actions';

class ShoutBox extends Component {
	static defaultProps = {
		duration: options.animationDuration,
		fullscreenScale: options.fullscreenShoutScale,
		userNameDefaultVisibility: 'visible',
	};

	static propTypes = {
		message: PropTypes.string.isRequired,
		user: PropTypes.string.isRequired,
		// Props are used in animations
		// eslint-disable-next-line react/no-unused-prop-types
		duration: PropTypes.number,
		// eslint-disable-next-line react/no-unused-prop-types
		fullscreenScale: PropTypes.number,
		// eslint-disable-next-line react/no-unused-prop-types
		userNameDefaultVisibility: PropTypes.string,
	};

	constructor(props) {
		super(props);
		this.messageContainer = React.createRef();
		this.name = React.createRef();
		this.wrapperContainer = React.createRef();

		this.animateFullScreen = animateFullScreen.bind(this);
		this.animateToBackground = animateToBackground.bind(this);
		this.animateToGrid = animateToGrid.bind(this);

		this.bindRotateAnimation = bindRotateAnimation.bind(this);
		this.bindUserRotateAnimation = bindUserRotateAnimation.bind(this);

		this.toggleAnimations = toggleAnimations.bind(this);
		this.prepareAnimations = prepareAnimations.bind(this);
	}

	componentDidMount() {
		this.prepareAnimations();
		const { dispatch } = this.props;
		dispatch({ type: actions.submission.SUBMISSION_INIT });
	}

	componentDidUpdate(prevProps) {
		this.toggleAnimations(prevProps);
	}

	static getFontSize(text) {
		const textLength = text.length;
		if (textLength > 10) {
			return 0.5 + ((1 / ((textLength / 36) - 0.25)) * 0.44);
		}

		return 1;
	}

	render() {
		const {
			message, user, fullscreen, idx,
		} = this.props;
		const username = truncate(user, { length: 17, separator: ' ', omission: '' });
		return (
			<React.Fragment>
				<TextBoxWrapper ref={this.messageContainer} fullscreen={fullscreen} idx={idx}>
					<div ref={this.wrapperContainer}>
						<MessageWrapper>
							<Message>
								<ClampLines
									text={message}
									lines={3}
									ellipsis="..."
									buttons={false}
								/>
							</Message>
							<Triangle />
						</MessageWrapper>
						<User ref={this.name} style={{ fontSize: `${ShoutBox.getFontSize(username)} em` }}><p>{username}</p></User>
					</div>
				</TextBoxWrapper>
			</React.Fragment>
		);
	}
}

export default ShoutBox;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/shoutboxvisualization/Shoutbox.component.js